import { SkeletonTheme } from 'react-loading-skeleton';
import { useTheme } from '../hooks/useTheme';
import { useAuth } from '../hooks/useAuth';
import { WithAuth } from './WithAuth';
import { WithoutAuth } from './WithoutAuth';

const App = () => {
  const { propsTheme } = useTheme();
  const { signed } = useAuth();

  return (
    <SkeletonTheme
      baseColor={propsTheme && propsTheme.background}
      highlightColor={propsTheme && propsTheme.border_color}
    >
      {signed ? <WithAuth /> : <WithoutAuth />}
    </SkeletonTheme>
  );
};

export default App;
